export default __webpack_public_path__ + "static/avatar_12-258a8d9c37ea6f1bd839f95c1559843e.svg";